import { useQuery } from '@apollo/client';
import { PageLayoutProps } from '.';
import { StaffSectionLayoutContainerStaffRoleFieldsFragment, StaffSectionLayoutContainerStaffUserCurrentDocument } from '../../../generated';
import { useOid } from '../../../hooks/useOid';
import { ComponentQueryLoader } from '../../shared/component-query-loader';
import { getStaffUserCurrentQueryOptionsWithOidAndCacheEnabled } from '../../shared/utils/queryOptions';
import { SectionLayout } from './section-layout';

interface SectionLayoutContainerProps {
  pageLayouts: PageLayoutProps[];
}

export const SectionLayoutContainer: React.FC<SectionLayoutContainerProps> = (props) => {
  const oid = useOid();
  const staffUserCurrentQueryOptions = getStaffUserCurrentQueryOptionsWithOidAndCacheEnabled(oid);

  const { data, loading, error } = useQuery(StaffSectionLayoutContainerStaffUserCurrentDocument, staffUserCurrentQueryOptions);

  return (
    <ComponentQueryLoader
      loading={loading}
      error={error}
      hasData={data?.staffUserCurrent?.role}
      hasDataComponent={
        <SectionLayout
          isAccessBlocked={data?.staffUserCurrent?.accessBlocked as boolean}
          pageLayouts={props.pageLayouts}
          roleData={data?.staffUserCurrent?.role as StaffSectionLayoutContainerStaffRoleFieldsFragment}
        />
      }
    />
  );
};
